import { styled } from 'stitches.config'

export const DifferenceItemRoot = styled('li', {
  maxWidth: '296px',
})
